import { useState } from 'react';

const useManagePages = pageSize => {
  const [managedPages, setManagedPages] = useState({});

  // if id has no page, init to 1, if it has return the page of the id
  const getPage = id => {
    if (!managedPages[id]) {
      managedPages[id] = 1;
    }
    return managedPages[id];
  };

  const nextPage = id => {
    managedPages[id] = getPage(id) + 1;
    return managedPages[id];
  };

  const getOffset = id => (getPage(id) - 1) * pageSize;

  return {
    pageSize,
    getPage,
    nextPage,
    getOffset,
    managedPages,
    setManagedPages
  };
};

export default useManagePages;
